export default __webpack_public_path__ + "static/media/fo.7844db71.svg";